import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { FacilityAddLocationComponent } from "./facility-add-location/facility-add-location.component";
import { FacilityEditLocationComponent } from "./facility-edit-location/facility-edit-location.component";

@Component({
	selector: "caass-siteadmin-facility-locations",
	templateUrl: "./siteadmin-facility-locations.component.html",
	styleUrls: ["./siteadmin-facility-locations.component.css"],
})
export class SiteadminFacilityLocationsComponent implements OnInit {
	constructor(private dialogService: DialogService) {}

	ngOnInit(): void {
		//Update data from main
		if (this.lstLocationsFromMain != undefined) {
			this.lstLocations = this.lstLocationsFromMain;

			for (var i = 0; i < this.lstLocations.length; i++) {
				var next = this.lstLocations[i];

				next.ActiveDesc = next.Active == 1 ? "Active" : "Inactive";
			}
		}
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////
	@Output() NextClick: EventEmitter<any> = new EventEmitter();
	@Input() lstLocationsFromMain: any;
	@Input() EditMode: any = false;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedLocations: any = [];
	lstLocations: any = [];

	//Filter lists
	lstActiveDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "FacilityLocationCD", header: "Code" },
		{ field: "FacilityLocationName", header: "Location Name" },
		{ field: "ActiveDesc", header: "Defined By" },
	];

	///////////////

	LocationToEdit: any;

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	//Custom Button Methods
	onAdd() {
		this.errorMessage = "";

		var ref = this.dialogService.open(FacilityAddLocationComponent, {
			header: "Add Location",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				lstLocations: this.lstLocations,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response != 0) {
				this.onRowUnselect(null);

				var min: number = 0;

				for (var i = 0; i < this.lstLocations.length; i++) {
					var next = this.lstLocations[i];

					if (Number(next.FacilityLocationID) < min) {
						min = next.FacilityLocationID;
					}
				}

				response.FacilityLocationID = min - 1;

				this.lstLocations = [...this.lstLocations, response];

				this.SelectedLocations = [];
			}
		});
	}

	onEdit() {
		this.errorMessage = "";

		if (this.SelectedLocations.length == 0) {
			this.errorMessage = "Select a location to edit";
			return;
		}

		if (this.SelectedLocations.length > 1) {
			this.errorMessage = "Select one location to edit";
			return;
		}

		var ref = this.dialogService.open(FacilityEditLocationComponent, {
			header: "Edit Location",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SelectedLocations: this.SelectedLocations,
				lstLocations: this.lstLocations,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response != 0) {
				this.SelectedLocations[0].FacilityLocationCD = response.FacilityLocationCD;
				this.SelectedLocations[0].FacilityLocationName = response.FacilityLocationName;

				//this.lstLocations = this.lstLocations.filter(location =>  this.SelectedLocations.indexOf(location) == -1 );
				//this.lstLocations = [...this.lstLocations, response];

				this.SelectedLocations = [];
				this.onRowUnselect(null);
			}
		});
	}

	onRemove() {
		this.errorMessage = "";

		if (this.SelectedLocations.length == 0) {
			this.errorMessage = "Select locations to remove";
			return;
		}

		for (var i = 0; i < this.SelectedLocations.length; i++) {
			var next = this.SelectedLocations[i];

			if (next.FacilityLocationID > 0) {
				this.errorMessage = "Facilities in the Database can only be deactivated";

				next.ActiveDesc = "Inactive";
			}
		}

		//Error handling
		this.lstLocations = this.lstLocations.filter((location) => this.SelectedLocations.indexOf(location) == -1 || location.FacilityLocationID > 0);

		//Remove deleted entries from selected locations
		this.SelectedLocations = this.SelectedLocations.filter((location) => this.lstLocations.indexOf(location) >= 0);
	}

	onToggle() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedLocations.length == 0) {
			this.errorMessage = "Select locations to toggle";
			return;
		}

		for (var i = 0; i < this.SelectedLocations.length; i++) {
			var next = this.SelectedLocations[i];

			if (next.ActiveDesc == "Active") {
				next.ActiveDesc = "Inactive";
			} else {
				next.ActiveDesc = "Active";
			}
		}
	}

	onNext() {
		//Error handling

		//testing
		this.FinishNext();
	}

	FinishNext() {
		let myData: any = {
			lstLocations: this.lstLocations,
		};

		this.NextClick.emit({
			NextPage: 2,
			Data: myData,
		});
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";
	}
	onRowUnselect(val) {
		this.errorMessage = "";
	}
	// onRowDblClick(Location){
	//   this.LocationToEdit = Location;
	//   this.onEdit();
	// }
	////////////////////////////////////////////
}
